<template>
	<div>
		<BaseEmpty>
			<section>
				<Filters
					:showFiltersForm="showFiltersForm"
					:optionsCategory="category.filter(ele => !ele.inactive)"
					:showOptionsfilter="[
						'grouping',
						'month',
						'year',
						'type',
						'category'
					]"
					:expandedAdvancedFilters="true"
					@clickSearch="search"
					@clickClose="closeFilters"
				/>
			</section>
		</BaseEmpty>
		<Base addWidth="30px" style="margin-top: 0px;">
			<div
				class="filter"
				v-bind:class="[showFiltersForm ? 'filter-active' : '']"
				@click="filterDropDownActive"
				title="Alterar Filtros"
			>
				<FilterIcon/>
			</div>
			<div>
				<ChartMedia
					:title="`Análise Comparativa`"
					:showXAxisLabel="true"
					:showZoom="true"
					:chartKey="2"
					:showLegend="true"
					:filters="filters"
				/>
			</div>
		</Base>
	</div>
</template>

<script>
	import Base from "@/templates/Base";
	import BaseEmpty from "@/templates/BaseEmpty.vue";
	import ChartMedia from "@/components/charts/ChartMedia.vue";
	import Filters from "@/components/Transactions/Filters.vue";
	import { mapState } from "vuex";

	export default {
		components: {
			ChartMedia,
			Base,
			BaseEmpty,
			Filters
		},

		data () {
			return {
				filters: {},
				showFiltersForm: false
			};
		},

		computed: {
			...mapState(["account", "category", "customer"])
		},

		watch: {
		},

		async mounted () {
		},

		methods: {
			search (filtersSelected) {
				this.filters = {
					monthsSelected: filtersSelected.monthsSelected,
					yearsSelected: filtersSelected.yearsSelected,
					groupingSelected: filtersSelected.groupingSelected,
					typeChartSelected: filtersSelected.typeChartSelected[0].value,
					categorySelected: filtersSelected.idsCategory
				};
				this.closeFilters();
			},

			filterDropDownActive () {
				this.showFiltersForm = !this.showFiltersForm;
			},

			closeFilters () {
				this.showFiltersForm = false;
			}
		}
	};
</script>